export default __webpack_public_path__ + "static/bed-bath-beyond-pipeline-0b08d0c54b64ddee669e3ea43c0eff4c.webp";